import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddPumpDetails = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [material, setMaterial] = useState([]);
  const [rowAddData, setRowAddData] = useState({
    pump_name: "",
    location: "",
    company_id: "",
  });
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedMaterialId, setSelectedMaterialId] = useState("");
  // console.log(selectedMaterialId)

  function resetFileds() {
    setRowAddData({
      pump_name: "",
      location: "",
      company_id: "",
    });
    setSelectedCompanyId("");
  }

  const handleCompanyChange = (e) => {
    setSelectedCompanyId(e.target.value);
  };
  const handleMaterialChange = (e) => {
    setSelectedMaterialId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { pump_name, location } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/pump/pump-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pump_name,
        location,
        company_id: selectedCompanyId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Pump Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleCompanyChange}
                              value={selectedCompanyId}
                              required
                              id="company_id"
                            >
                              <option value="">Select Company Name</option>
                              {company &&
                                company.length > 0 &&
                                company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="pump_name">Pump Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="pump_name"
                              id="pump_name"
                              placeholder="Pump Name"
                              onChange={handleChange}
                              value={rowAddData.pump_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="location"
                              placeholder="Location"
                              onChange={handleChange}
                              value={rowAddData.location}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPumpDetails;
